import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import actions from 'actions/index.js';
import Cookies from "js-cookie";
import axios from 'axios';
import {API_URL} from 'constants/index.js';
import InputCustom from 'views/pages/components/InputCustom';
import InputFile from 'views/pages/components/InputFile';

import {Card, CardBody, CardHeader, Col, Container, Row,} from "reactstrap";

import CardsHeader from 'layouts/Headers/CardsHeader.js';
import InputToggle from "@pages/components/InputToggle";
import {ButtonContainer, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import notify from "@utils/notify";
import {StyledImage} from "@pages/new-design-components/custom-components";
import ButtonWithLoader from "@pages/reusable-components/ButtonWithLoader";

export default function Profile() {
  const profileData = useSelector((state) => state.getState).profileData;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    type: 'password',
    loading: false
  });
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [imageFile, setImageFile] = useState({});
  const [isDriver, setIsDriver] = useState(0);
  const [isNotValid, setIsNotValid] = useState(false);
  const [token, setToken] = useState('');

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [detailErrors, setDetailErrors] = useState('');
  const [passwordErrors, setPasswordErrors] = useState('');

  const data = profileData? profileData: { data: {name: '', email: ''} };

  const pullAsyncData = () => {
    if (Cookies.get('grs_token')) {
      let token = Cookies.get('grs_token');
      setToken(token);
      dispatch(actions.getProfileData(token));
    }
  }

  useEffect(() => {
    pullAsyncData()
  }, [])

  useEffect(() => {
    setName(data.name);
    setEmail(data.email);
    setIsDriver(data.is_driver ? 1 : 0);
  }, [data])
  const saveUserInformation = () => {
    setLoading({
      type: 'profile',
      loading: true
    })
    let formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    if(imageFile?.image) {
      formData.append('photo', imageFile?.image);
    }
    formData.append('is_driver', isDriver);

    axios({
      method: 'POST',
      url: API_URL + '/profile',
      data: formData,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(response => {
        setLoading({
          type: 'profile',
          loading: false
        })
        if (response.status === 200) {
          setDetailErrors('');
          setImageFile({})
          notify.success('Successfully Updated')
          dispatch(actions.getProfileData(token));
        }
      })
      .catch(error => {
        setLoading({
          type: 'profile',
          loading: false
        })
        if (error.response.status === 422) {
          let errors = error.response.data.errors;
          setDetailErrors(errors);
          notify.warning(error.response.data.message)
          return
        }
        notify.error(error.response.statusText)
      })
  }

  const changePassword = () => {
    setLoading({
      type: 'password',
      loading: true
    })
    let formData = new FormData();
    formData.append('old_password', currentPassword);
    formData.append('password', newPassword);
    formData.append('password_confirmation', confirmPassword);

    axios({
      method: 'POST',
      url: API_URL + '/password',
      data: formData,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(response => {
        if (response.status === 200) {
          setPasswordErrors('');
          notify.success('Successfully Updated')
          setCurrentPassword('');
          setNewPassword('');
          setConfirmPassword('');
          setLoading({
            type: 'password',
            loading: false
          })
        }
      })
      .catch(error => {
        console.log('error :: ', error.response);
        setLoading({
          type: 'password',
          loading: false
        })
        if (error.response.status === 422) {
          let errors = error.response.data.errors;
          notify.error(error.response.data.message)
          setPasswordErrors(errors);

          return
        }
        notify.warning(error.response.statusText);
      })
  }
  const handleChange = async (file) => {
    if (file) {
      await onFileSelect(file);
    }
  }
   const clearFile = () => {
     setImageFile({})
   }
  const onFileSelect = async (file) => {
    if (file) {
      let reader = new FileReader();
      reader.readAsDataURL(file)
      const preview =  URL.createObjectURL(file)
      setImageFile( {
       preview: preview,
       image: file,
      })
    }
  }
  return (
        !Object.values(data).length ? <LoaderContainer>
              <ClipLoader
                  size={40}
                  color={`#7B61E4`}
              />
            </LoaderContainer>:
            <>
              <CardsHeader name="Admin" parentName="Profile" />

              <Container className="mt--6 admin-main-body" fluid >
                <Row>
                  <Col xl="12">
                    <Card>
                      <CardHeader>
                        <h2 className="title mb-0 main-color">Edit Profile</h2>
                      </CardHeader>
                      <CardBody>

                        <Row  className={'phone-container'}>
                          <Col>
                            <h3 className="surtitle mb-4">User Information</h3>
                            <Col >
                              <InputCustom
                                  newLabel={`Name`}
                                  required={true}
                                  placeholder={`Name`}
                                  value={name? name: ''}
                                  setIsNotValid={setIsNotValid}
                                  onChange={(e) => setName(e.target.value)}
                                  invalid={detailErrors && detailErrors.name? true: false}
                                  errorMessage={detailErrors.name}
                              />
                            </Col>
                            <Col>
                              <InputCustom
                                  type={`email`}
                                  newLabel={`Email`}
                                  required={true}
                                  checkEmail={true}
                                  setIsNotValid={setIsNotValid}
                                  placeholder={`Email`}
                                  value={email? email: ''}
                                  onChange={(e) => setEmail(e.target.value)}
                                  invalid={detailErrors && detailErrors.email? true: false}
                                  errorMessage={detailErrors.email}
                              />
                            </Col>
                            <Col >
                              <InputFile
                                  label={`Profile photo`}
                                  preview={imageFile?.preview}
                                  clearFile={clearFile}
                                  placeholder={`Select file`}
                                  onChange={(e) => handleChange(e.target.files[0])}
                                  invalid={detailErrors && detailErrors.photo? true: false}
                                  errorMessage={detailErrors.photo}
                              />

                            </Col>
                           <Row>
                             <Col md={4} className={'ml-3'}>
                               <InputToggle
                                   side
                                   label={`Is driver`}
                                   checked={isDriver}
                                   onChange={() =>
                                       setIsDriver((prevCheck => prevCheck === 1 ? 0 : 1))
                                   }
                               />
                             </Col>
                             <Col md={7}>
                               <div className={'d-flex justify-content-end'}>
                                 <ButtonWithLoader
                                     reverse
                                     width={'unset'}
                                     onClick={saveUserInformation}
                                     loading={loading.type === 'profile' && loading.loading}
                                     text={'Save'}
                                 />

                               </div>
                             </Col>
                           </Row>

                          </Col>
                          <Col>
                            <h3 className="surtitle mb-4">Password</h3>
                            <Col>
                              <InputCustom
                                  type={`password`}
                                  newLabel={`Current password`}
                                  placeholder={`Current password`}
                                  value={currentPassword}
                                  onChange={(e) => setCurrentPassword(e.target.value)}
                                  invalid={passwordErrors && passwordErrors.old_password? true: false}
                                  errorMessage={passwordErrors.old_password}
                              />
                            </Col>
                            <Col>
                              <InputCustom
                                  type={`password`}
                                  newLabel={`New password`}
                                  placeholder={`New password`}
                                  value={newPassword}
                                  onChange={(e) => setNewPassword(e.target.value)}
                                  invalid={passwordErrors && passwordErrors.password? true: false}
                                  errorMessage={passwordErrors.password}
                              />
                            </Col>
                            <Col>
                              <InputCustom
                                  type={`password`}
                                  newLabel={` Confirm new password`}
                                  placeholder={` Confirm new password`}
                                  value={confirmPassword}
                                  onChange={(e) => setConfirmPassword(e.target.value)}
                                  invalid={passwordErrors && passwordErrors.password_confirmation? true: false}
                                  errorMessage={passwordErrors.password_confirmation}
                              />
                            </Col>
                            <div className={'d-flex justify-content-end'}>
                              <ButtonWithLoader
                                text={'Change Password'}
                                width={'unset'}
                                reverse={true}
                                loading={loading.type === 'password' && loading.loading}
                                onClick={changePassword}
                              />

                            </div>
                          </Col>
                        </Row>

                        <hr />


                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </>
  );
}